import { render, staticRenderFns } from "./DynamicFileField.vue?vue&type=template&id=8df97704&scoped=true&"
import script from "./DynamicFileField.vue?vue&type=script&lang=js&"
export * from "./DynamicFileField.vue?vue&type=script&lang=js&"
import style0 from "./DynamicFileField.vue?vue&type=style&index=0&id=8df97704&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df97704",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VFileInput,VIcon})
